import Node from 'ln/node/Node';
import Template from "ln/template/TemplateManager";
import BaseCourseListFilterView from './BaseCourseListFilterView';
import CourseModel from '../../course/models/CourseModel';
import UserCourseModel from '../../course/models/UserCourseModel';
import setup from 'ln/setup/setup';
import { backend } from '../../setup';
import { scanner } from 'ln/view/Scanner';

interface IComparisonAttributes{
	tagFilterAttributes: Array<string>;
	searchFilterAttributes: Array<string>;
}


class CourseListFilterView extends BaseCourseListFilterView {

	public constructor( courses:Array<CourseModel|UserCourseModel>, comparisonAttributes:IComparisonAttributes ) {
		super( courses, comparisonAttributes);
	}
	
	/**
	 * @overwrite
	 */
	protected renderCourses() {

		super.renderCourses();

		this.courseListRenderer.ioc.add( 'App\\Course', ( item:CourseModel ) => {
			var node = Node.fromHTML( Template.render( 'krw.courselistcourse-standard', item ) );
			scanner.scan( node );
			return { node : node };
		});

		this.courseListRenderer.ioc.add( 'App\\UserCourse', ( item:UserCourseModel ) => {
			var node = Node.fromHTML( Template.render( 'krw.courselistcourse-editable', item ) );
			node.one( '.delete-course' ).click.add( () => {
				this.showDialog( item, this.deleteCourse.bind( this ), 'library.dialog.confirm-delete' );
			});
			node.one( '.duplicate-course' ).click.add( () => {
				this.duplicateCourse( item );
			});
			scanner.scan( node );
			return { node : node };
		});

		// display "no matching entries found" if list is empty
		this.courseList.filled.add( function( items:any[] ) {
			this.node.one( '.empty' ).toggleClass( 'hidden', items.length > 0 );
		}, this);
		this.courseList.originals.removed.add( function( removedItem:any, index:number ) {
			this.node.one( '.empty' ).toggleClass( 'hidden', this.courseList.originals.length > 0 );
		}, this);

		this.courseListRenderer.source = this.courseList;
	}
	
	/**
	 * Delete the given course
	 */
	private deleteCourse( course:UserCourseModel ){
		course.delete().then( () => {
			this.courseList.originals.remove( course );
		});
	}

	/**
	 * Duplicates a course
	 */
	private duplicateCourse( course:UserCourseModel ) {

		var courses = this.courseList.originals;

		setup.route( 'api.duplicate.course', { id: course.id } ).load().then( ( result ) => {

			var duplicated = backend.mapper.model( result ) as UserCourseModel;
			courses.add( duplicated, courses.index( course ) + 1 );
		});
	}
}

export default CourseListFilterView;